import { compose } from 'recompose';
import { connect } from 'react-redux';
import { IStore } from 'Store/.';
import { getSlidingMessage } from 'Store/Banners/selectors';
import MessageSlider from 'Components/MessageSlider/MessageSlider';

const mapStateToProps = (state: IStore) => {
  return {
    message: getSlidingMessage(state),
  };
};

export default compose<{}, {}>(
  connect(mapStateToProps, null),
)(MessageSlider);


// WEBPACK FOOTER //
// ./src/components/MessageSlider/MessageSliderContainer.tsx